/*
=========================================================
* Material Kit 2 React - v2.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-kit-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";

// Material Kit 2 React components
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";

// Material Kit 2 React examples
import DefaultNavbar from "bachrosenComponents/bachNavbar";
import CenteredFooter from "bachrosenComponents/centeredFooter";
// import HorizontalBlogCard from "examples/Cards/BlogCards/HorizontalBlogCard";
import BachHeader from "bachrosenComponents/bachHeader";

// Routes
import routes from "routes";
import footerRoutes from "footer.routes";

// Images
import bgImage from "assets/images/home1.jpg";

function ManagementSite() {
  const management = `
    Präsident: Manuel Müller <br />
    2. Vorstand: Florian Erne <br />
    3. Vorstand: Thomas Müller <br />
    4. Vorstand: Michael Stumpf <br />
    Säckelmeister: Oliver Bertsche <br />
    Schriftführer: Lukas Bertsche <br />
    Bolizei: Jürgen Schober <br />
    Beisitzer: Reinhold Brucker <br />
    Beisitzer: Udo Brucker <br />
    Beisitzer: Michael König <br />
    Beisitzer: Herbert Müller <br />
    Beisitzer: Rolf Bohl <br />
    Beisitzer: Robert Muffler <br /><br />
    `;
  const ministries = `
    Bachrosenvertreter: Doris Erne <br />
    Gärtnervertreter: Daniel König <br />
    Kassenprüfer: Fabian Traber <br />
    Kassenprüfer: Felix Müller <br />`;
  // Social-Media Manager: Sina Müller <br />`;

  return (
    <>
      <MKBox position="fixed" top="0.5rem" width="100%">
        <DefaultNavbar routes={routes} dark info center />
      </MKBox>
      <BachHeader image={bgImage} title="Vorstandschaft" />
      {/* <MKBox
        minHeight="75vh"
        width="100%"
        sx={{
          backgroundImage: ({ functions: { linearGradient, rgba }, palette: { gradients } }) =>
            `${linearGradient(
              rgba(gradients.dark.main, 0.6),
              rgba(gradients.dark.state, 0.6)
            )}, url(${bgImage})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          display: "grid",
          placeItems: "center",
        }}
      >
        <MKTypography
          align="center"
          variant="h1"
          color="white"
          sx={({ breakpoints, typography: { size } }) => ({
            [breakpoints.down("md")]: {
              fontSize: size["3xl"],
            },
          })}
        >
          Vorstandschaft
        </MKTypography>
      </MKBox> */}

      <Card
        sx={{
          // p: 2,
          mx: { xs: 2, lg: 3 },
          mt: -8,
          mb: 4,
          boxShadow: ({ boxShadows: { xxl } }) => xxl,
        }}
      >
        <Container>
          <Grid container spacing={3} mb={4}>
            <Grid item xs={12} lg={6}>
              <MKBox mb={1}>
                <MKBox
                  bgColor="white"
                  borderRadius="xl"
                  shadow="lg"
                  display="flex"
                  flexDirection="column"
                  justifyContent="center"
                  mt={{ xs: 10, sm: 9, md: 10 }}
                  mx={1}
                >
                  <MKBox
                    variant="gradient"
                    bgColor="success"
                    coloredShadow="success"
                    borderRadius="lg"
                    p={2}
                    mx={2}
                    mt={-3}
                  >
                    <MKTypography variant="h3" color="white">
                      Elferrat
                    </MKTypography>
                  </MKBox>
                  <MKBox p={3}>
                    <MKTypography
                      variant="body2"
                      color="text"
                      mb={3}
                      dangerouslySetInnerHTML={{ __html: management }}
                    />
                  </MKBox>
                </MKBox>
              </MKBox>
            </Grid>
            <Grid item xs={12} lg={6}>
              <MKBox mb={1}>
                <MKBox
                  bgColor="white"
                  borderRadius="xl"
                  shadow="lg"
                  display="flex"
                  flexDirection="column"
                  justifyContent="center"
                  mt={{ xs: 10, sm: 9, md: 10 }}
                  mb={{ xs: 20, sm: 18, md: 20 }}
                  mx={1}
                >
                  <MKBox
                    variant="gradient"
                    bgColor="success"
                    coloredShadow="success"
                    borderRadius="lg"
                    p={2}
                    mx={2}
                    mt={-3}
                  >
                    <MKTypography variant="h3" color="white">
                      weitere Ämter
                    </MKTypography>
                  </MKBox>
                  <MKBox p={3}>
                    <MKTypography
                      variant="body2"
                      color="text"
                      mb={3}
                      dangerouslySetInnerHTML={{ __html: ministries }}
                    />
                  </MKBox>
                </MKBox>
              </MKBox>
            </Grid>
          </Grid>
        </Container>
      </Card>
      <MKBox px={1} mt={6}>
        <CenteredFooter content={footerRoutes} />
      </MKBox>
    </>
  );
}

export default ManagementSite;
